module.exports = __webpack_public_path__ + "static/media/banner.ae664fcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/Main/images/banner.png
// module id = 967
// module chunks = 0